import Tile from './VideoTile';
import Stg from './Stage';

export const VideoTile = Tile;
export const Stage = Stg;